import { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";
import { PageHeader } from "../components/Bits";
import { QrCode, Building2, ShieldAlert, Phone } from "lucide-react";

export default function Payment() {
  const [pay, setPay] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setPay((r.data || {}).payment || {})); }, []);

  return (
    <div data-testid="payment-page">
      <PageHeader title="Payment & Dues" subtitle="Pay membership renewal and other dues to the Association." />
      <section className="max-w-5xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10">
        <div className="card-elite rounded-lg p-8 text-center" data-testid="payment-qr-card">
          <h3 className="font-display text-2xl font-semibold text-[#0B2E63] mb-1">Scan &amp; Pay via UPI</h3>
          <div className="gold-rule w-16 mx-auto mb-6" />
          <div className="mx-auto w-64 h-64 rounded-lg border-2 border-[#E6C687] bg-white flex items-center justify-center overflow-hidden">
            {pay.qr_path ? (
              <img src={fileUrl(pay.qr_path)} alt="Payment QR" className="w-full h-full object-contain p-2" data-testid="payment-qr-img" />
            ) : (
              <div className="text-center text-[#8A6320] px-6">
                <QrCode size={64} className="mx-auto mb-3" />
                <p className="text-sm text-[#5A6270]">QR code will be uploaded by the Association.</p>
              </div>
            )}
          </div>
          <p className="mt-5 text-sm font-semibold uppercase tracking-widest text-[#8A6320]">Please pay in this bar code</p>
        </div>

        <div className="space-y-6">
          <div className="card-elite rounded-lg p-6" data-testid="bank-card">
            <h3 className="font-display text-xl font-semibold text-[#0B2E63] flex items-center gap-2 mb-4"><Building2 size={20} /> Bank Transfer</h3>
            <dl className="space-y-3 text-sm">
              {[["Bank", pay.bank_name], ["Account Name", pay.account_name], ["Account No.", pay.account_no], ["IFSC", pay.ifsc]].map(([k, v]) => (
                <div key={k} className="flex justify-between gap-4 border-b border-[#F0E9DA] pb-2">
                  <dt className="text-[#5A6270] shrink-0">{k}</dt>
                  <dd className="font-medium text-[#2a2422] text-right">{v || "—"}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="rounded-lg p-6 bg-[#EAF1FB] border border-[#123B7A]/30" data-testid="payment-disclaimer">
            <h3 className="font-display text-lg font-semibold text-[#0B2E63] flex items-center gap-2 mb-2"><ShieldAlert size={18} /> Disclaimer</h3>
            <p className="text-sm text-[#3a4250] leading-relaxed">
              In case of any doubts, members are requested to verify the payment details before making any payment. For any queries, kindly contact the office.
            </p>
            <div className="mt-3 space-y-1.5 text-sm">
              <a href="tel:9907267718" className="flex items-center gap-2 text-[#123B7A] font-semibold" data-testid="office-mobile"><Phone size={14} /> 9907267718 (Office Mobile)</a>
              <a href="tel:07612626219" className="flex items-center gap-2 text-[#123B7A] font-semibold" data-testid="office-landline"><Phone size={14} /> 0761 2626 219 (Landline)</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
